// Fetch all parking permit types
export const FETCH_PARKING_PERMIT_TYPES = 'FETCH_PARKING_PERMIT_TYPES';
export const FETCH_PARKING_PERMIT_TYPES_SUCCESS = 'FETCH_PARKING_PERMIT_TYPES_SUCCESS';
export const FETCH_PARKING_PERMIT_TYPES_FAILURE = 'FETCH_PARKING_PERMIT_TYPES_FAILURE';

// Create parking permit type
export const CREATE_PARKING_PERMIT_TYPE = 'CREATE_PARKING_PERMIT_TYPE';
export const CREATE_PARKING_PERMIT_TYPE_SUCCESS = 'CREATE_PARKING_PERMIT_TYPE_SUCCESS';
export const CREATE_PARKING_PERMIT_TYPE_FAILURE = 'CREATE_PARKING_PERMIT_TYPE_FAILURE';

// Update parking permit type
export const UPDATE_PARKING_PERMIT_TYPE = 'UPDATE_PARKING_PERMIT_TYPE';
export const UPDATE_PARKING_PERMIT_TYPE_SUCCESS = 'UPDATE_PARKING_PERMIT_TYPE_SUCCESS';
export const UPDATE_PARKING_PERMIT_TYPE_FAILURE = 'UPDATE_PARKING_PERMIT_TYPE_FAILURE';

// Deactivate parking permit type
export const DEACTIVATE_PARKING_PERMIT_TYPE = 'DEACTIVATE_PARKING_PERMIT_TYPE';
export const DEACTIVATE_PARKING_PERMIT_TYPE_SUCCESS = 'DEACTIVATE_PARKING_PERMIT_TYPE_SUCCESS';
export const DEACTIVATE_PARKING_PERMIT_TYPE_FAILURE = 'DEACTIVATE_PARKING_PERMIT_TYPE_FAILURE';

// Fetch permit type transaction documents
export const FETCH_PERMIT_TYPE_TRANS_DOCS = 'FETCH_PERMIT_TYPE_TRANS_DOCS';
export const FETCH_PERMIT_TYPE_TRANS_DOCS_SUCCESS = 'FETCH_PERMIT_TYPE_TRANS_DOCS_SUCCESS';
export const FETCH_PERMIT_TYPE_TRANS_DOCS_FAILURE = 'FETCH_PERMIT_TYPE_TRANS_DOCS_FAILURE';

// Fetch auto-assign config for a permit type
export const FETCH_AUTO_ASSIGN_CONFIG = 'FETCH_AUTO_ASSIGN_CONFIG';
export const FETCH_AUTO_ASSIGN_CONFIG_SUCCESS = 'FETCH_AUTO_ASSIGN_CONFIG_SUCCESS';
export const FETCH_AUTO_ASSIGN_CONFIG_FAILURE = 'FETCH_AUTO_ASSIGN_CONFIG_FAILURE';

// Update auto-assign config for a permit type
export const UPDATE_AUTO_ASSIGN_CONFIG = 'UPDATE_AUTO_ASSIGN_CONFIG';
export const UPDATE_AUTO_ASSIGN_CONFIG_SUCCESS = 'UPDATE_AUTO_ASSIGN_CONFIG_SUCCESS';
export const UPDATE_AUTO_ASSIGN_CONFIG_FAILURE = 'UPDATE_AUTO_ASSIGN_CONFIG_FAILURE';
